<div class="keyword-limit-modal">
  <!-- Header with gradient background -->
  <div class="kw-modal-header">
    <div class="header-icon">
      <img src="../../../assets/img/organic_icon_2.svg" style="width: 32px; height: 32px; border-radius: 6px" />
    </div>
    <h2 class="kw-modal-title">No Keywords Left</h2>
    <p class="kw-modal-subtitle">You've reached your keyword limit for <b>{{ getProjectName() }}</b></p>
  </div>

  <!-- Content section -->
  <div class="kw-modal-content">
    <div class="keyword-stats">
      <div class="stat-item">
        <div class="stat-number">{{ getRemainingKeywords() }}</div>
        <div class="stat-label">Keywords Remaining</div>
      </div>
    </div>

    <div class="info-section">
      <div class="info-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
            fill="#6366F1" />
        </svg>
      </div>
      <div class="info-text">
        <h3>Upgrade Your Plan</h3>
        <p>Get unlimited keywords, advanced analytics, and premium features to supercharge your SEO performance.</p>
      </div>
    </div>
  </div>

  <!-- Action buttons -->
  <div class="kw-modal-actions">

    <button class="primary btn_withoutIcon custom-button cstm-kw-btn" style="
    border: none !important;
    display: inline-block;
    background-color: #252525;
    padding: 10px 20px !important;
    border-radius: 10px;
    height: 36px !important;
    font-size: 14px!important;" mat-raised-button type="button" (click)="closeModal()">
      <span style="color: #fff !important; position: relative; top: 0px">Maybe Later</span>
    </button>
    <button class="primary btn_withoutIcon custom-button" style="
    border: none !important;
    display: inline-block;
    background-color: #635bff !important;
    padding: 10px 20px !important;
    border-radius: 10px;
    height: 36px !important;
    font-size: 14px!important;" mat-raised-button type="button" (click)="upgradePlan()" type="button">
      <span style="color: #fff !important; position: relative; top: 0px">Upgrade Now</span>
    </button>
  </div>
</div>